
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { Component, Vue, Ref } from 'vue-property-decorator'
import MediaService from '@/services/media-service'
import { AppModule } from '@/store/modules/app'
import { convertCodeToText, convertTextToCode } from '@/common/area_data'

const statusMap = {
    resolve: { 
        value: 2, name: '已通过' 
    },
    notCheck: { 
        value: 1, name: '未审核'
    },
    reject: { 
        value: 3, name: '不通过' 
    }
}

@Component({
    name: 'media-store',
    components: {
        FullLoading,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private pageSize = 100
    private pageIndex = 1
    private pageTotal = 0
    private query = ''
    private isLoading = true
    private mediaList = []
    private statusMap = statusMap
    private status = statusMap.resolve.value

    get regionData() {
        return AppModule.regionData
    }

    async mounted() {
        await AppModule.getRegion()
        this.getStoreList()
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getStoreList)
    }

    private async onStatusSelect(status: any, item: any) {
        this.$set(item, 'loading', true)
        // 更新状态值
        item.check = status
        try {
            const params = {
                id: item.id,
                intro: item.intro || '',
                address: item.address || '',
                region: item.regionText || '',
                status: item.check || item.status.id
            }
            const result = await MediaService.updateStoreStatus(params)
            if (result.status === 200) {
                this.$message({ type: 'success', message: '更新成功' })
                // 立即刷新列表
                this.getStoreList()
            } else {
                this.$message({ type: 'error', message: result.message || '更新失败' })
                // 恢复原状态
                item.check = item.status.id
            }
        } catch (error) {
            this.$message({ type: 'error', message: '保存失败' })
            // 恢复原状态
            item.check = item.status.id
        } finally {
            item.loading = false
        }
    }

    // 地域相关方法
    private onRegionClick(row: any) {
        this.$set(row, 'editingRegion', true)
        this.$set(row, 'regionCode', row.regionCode || [])
    }

    private onRegionChange(value: any, row: any) {
        if (value && value.length > 0) {
            this.$set(row, 'regionCode', value)
            this.$set(row, 'regionText', convertCodeToText(value))
        } else {
            this.$set(row, 'regionCode', [])
            this.$set(row, 'regionText', '')
        }
        this.saveAllFields(row)
    }


    private updateIntro(row: any, event: any) {
        const target = event.target as HTMLElement
        const newValue = target.textContent ? target.textContent.trim() : ''
        const oldValue = row.intro ? row.intro.trim() : ''
        if (newValue !== oldValue) {
            row.intro = newValue
            this.saveAllFields(row)
        }
    }

    private updateAddress(row: any, event: any) {
        const target = event.target as HTMLElement
        const newValue = target.textContent ? target.textContent.trim() : ''
        const oldValue = row.address ? row.address.trim() : ''
        if (newValue !== oldValue) {
            row.address = newValue
            this.saveAllFields(row)
        }
    }

    private async saveAllFields(row: any) {
        try {
            const params = { 
                id: row.id,
                intro: row.intro || '',
                address: row.address || '',
                region: row.regionText || '',
                status: row.check || row.status.id
            }
            const result = await MediaService.updateStoreStatus(params)
            if (result.status === 200) {
                this.$message({ type: 'success', message: '更新成功' })
            } else {
                this.$message({ type: 'error', message: result.message || '更新失败' })
            }
        } catch (error) {
            this.$message({ type: 'error', message: '保存失败' })
        }
    }
    /* 获取收录列表 */
    private async getStoreList() {
        const params = {
            query: this.query,
            page_index: this.pageIndex,
            page_size: this.pageSize,
            status: this.status
        }
        const result = await MediaService.getStoreList(params)
        if (result.status === 200) {
            this.isLoading = false
            this.pageTotal = result.data.page_total
            this.mediaList = result.data.list.map((n: any) => {

                let regionCode = []
                let regionText = ''
                
                if (n.province) {
                    const textArray = []
                    textArray.push(n.province)
                    
                    if (n.city) {
                        textArray.push(n.city)
                        
                        if (n.area) {
                            textArray.push(n.area)
                        }
                    }
                    
                    regionCode = convertTextToCode(textArray)
                    regionText = textArray.join(',')
                }
                // 修复：兼容 status 为数字或对象的情况
                const statusValue = typeof n.status === 'object' ? n.status.id : n.status
                return {
                    ...n, 
                    // check: n.status.id,
                    check: statusValue,  // 使用兼容后的值
                    status: typeof n.status === 'object' ? n.status : { id: statusValue },  // 统一为对象格式
                    regionCode: regionCode,
                    regionText: regionText,
                    editingRegion: false
                }
            })
        }
    }

    private onStatusFilter(status: number) {
        this.status = status
        this.pageIndex = 1
        this.getStoreList()
    }

}
